import { render, staticRenderFns } from "./crateBookings.vue?vue&type=template&id=5caeb839"
import script from "./crateBookings.vue?vue&type=script&lang=js"
export * from "./crateBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports